import { getHandler } from 'src/utils/fetchHandler';

export const GET_GIFT_DATE_BUCKETS = 'GET_GIFT_DATE_BUCKETS/GIFT_DATE_BUCKETS/@WISELY/WEB';
export const FETCH_GIFT_DATE_BUCKETS_FAILED =
	'FETCH_GIFT_DATE_BUCKETS_FAILED/GIFT_DATE_BUCKETS/@WISELY/WEB';
export const FETCH_GIFT_DATE_BUCKETS_SUCCEEDED =
	'FETCH_GIFT_DATE_BUCKETS_SUCCEEDED/GIFT_DATE_BUCKETS/@WISELY/WEB';

export const getGiftDateBuckets = () => ({
	type: GET_GIFT_DATE_BUCKETS,
});

export const fetchGiftDateBucketsSucceeded = payload => ({
	type: FETCH_GIFT_DATE_BUCKETS_SUCCEEDED,
	payload,
});

export const fetchGiftDateBucketsFailed = payload => ({
	type: FETCH_GIFT_DATE_BUCKETS_FAILED,
	payload,
});

export const fetchGiftDateBuckets = () => {
	return dispatch => {
		dispatch(getGiftDateBuckets());
		const path = `v2/gift_date_buckets`;

		return getHandler(path)
			.then(json => dispatch(fetchGiftDateBucketsSucceeded(json)))
			.catch(error => {
				console.error('fetchGiftDateBuckets error', error);
				dispatch(fetchGiftDateBucketsFailed(error));
			});
	};
};



// WEBPACK FOOTER //
// ./src/redux/giftDateBuckets/giftDateBucket.action.js